import { render } from "./Durable.vue?vue&type=template&id=08936c74&scoped=true"
import script from "./Durable.vue?vue&type=script&lang=js"
export * from "./Durable.vue?vue&type=script&lang=js"

import "./Durable.vue?vue&type=style&index=0&id=08936c74&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08936c74"]])

export default __exports__